import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import { RootState } from './types'
import { user } from './user'
import { app } from './app/index'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {},
  modules: {
    user,
    app
  }
}

export default new Vuex.Store<RootState>(store)
